module.exports = __webpack_public_path__ + "img/jdaji.7cef9d87.gif";